import { useSystemStore } from '@/stores/system'
import { systemConfig } from '@/utils/systemConfig'
import { createGUID, toQueryString } from '@/utils/tools'

const CLIENT_ID = 'a5cae5535dc24add98b60ce1f3a8915d'
const SCOPE = 'openid profile Acadsoc.Teacher.Api'
const RESPONSE_TYPE = 'id_token token'

async function fetchMetadata(authority) {
  let url = authority || ''
  if (url && !url.includes('.well-known/openid-configuration')) {
    if (!url.endsWith('/')) url += '/'
    url += '.well-known/openid-configuration'
  }
  const res = await fetch(url)
  if (!res.ok) throw new Error(`OIDC metadata failed: ${res.status}`)
  return res.json()
}

/**
 * Lightweight OIDC client — same client_id / scopes / redirect as Tutor.Web
 */
export class OidcClient {
  constructor() {
    const system = useSystemStore()
    this.authority = system.authorityUrl || systemConfig.authorityUrl
    this.redirectUri = `${window.location.origin}/oidc-callback`
    this.postLogoutRedirectUri = `${window.location.origin}/oidc-callback`
  }

  async createSigninRequest() {
    const meta = await fetchMetadata(this.authority)
    const params = {
      client_id: CLIENT_ID,
      redirect_uri: this.redirectUri,
      response_type: RESPONSE_TYPE,
      scope: SCOPE,
      state: createGUID().replace(/-/g, ''),
      nonce: createGUID().replace(/-/g, '')
    }
    return {
      url: `${meta.authorization_endpoint}?${toQueryString(params)}`
    }
  }

  async createSignoutRequest({ id_token_hint } = {}) {
    const meta = await fetchMetadata(this.authority)
    if (!meta.end_session_endpoint) {
      throw new Error('no end session endpoint')
    }
    const params = {
      id_token_hint,
      post_logout_redirect_uri: this.postLogoutRedirectUri,
      state: createGUID().replace(/-/g, '')
    }
    return {
      url: `${meta.end_session_endpoint}?${toQueryString(params)}`
    }
  }

  async singOut(args = {}) {
    const req = await this.createSignoutRequest(args)
    window.location = req.url
  }
}
